import React, { useState, useEffect, useMemo } from 'react';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import IconSuccess from '@/components/UI/Icons/svgs/Success';
import { ReactComponent as AlertWarn } from '@/images/icons/alert/warn.svg';
import moment from 'moment';
import styles from './OpenRecords.module.scss';
import { apiHolder, apis, getIn18Text } from 'api';
export const isThirdSendFn = (content) => {
    var _a, _b, _c;
    if (!((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.mTrack)) {
        if (((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.sendTime) && new Date((_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.sendTime).getTime() > new Date('2024-09-01').getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    return false;
};
const columnsWaimao = [
    {
        title: getIn18Text('DANGDISHIJIAN'),
        dataIndex: 'remoteLocalTime',
        key: 'remoteLocalTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('DAKAIDIDIAN'),
        dataIndex: 'location',
        key: 'location',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('BENDISHIJIAN'),
        dataIndex: 'settingTime',
        key: 'settingTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('IPDIZHI'),
        dataIndex: 'ip',
        key: 'ip',
        render: (text) => text || '--',
    },
];
const columnsLx = [
    {
        title: getIn18Text('DANGDISHIJIAN'),
        dataIndex: 'remoteLocalTime',
        key: 'remoteLocalTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('BENDISHIJIAN'),
        dataIndex: 'settingTime',
        key: 'settingTime',
        render: (text) => text || '--',
    },
];
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const OpenRecords = ({ content, openRecordData, getMailReadDetail, forbid = false }) => {
    const [open, setOpen] = useState(false);
    const id = useMemo(() => {
        return content === null || content === void 0 ? void 0 : content.id;
    }, [content]);
    const isThirdSend = useMemo(() => {
        return isThirdSendFn(content);
    }, [content]);
    const openText = useMemo(() => {
        return !!open ? getIn18Text('SHOUQI') : getIn18Text('XIANGQING');
    }, [open]);
    const showTable = useMemo(() => {
        var _a;
        return open && ((_a = openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.records) === null || _a === void 0 ? void 0 : _a.length);
    }, [open, openRecordData]);
    const oneRecordText = useMemo(() => {
        var _a;
        if (((_a = openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.records) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            const one = openRecordData.records[0];
            if (process.env.BUILD_ISEDM) {
                return getIn18Text('YOUJIANYU:Z(DDSJ:，IP:)BDK', {
                    settingTimeZone: (one === null || one === void 0 ? void 0 : one.settingTimeZone) || '--',
                    settingTime: (one === null || one === void 0 ? void 0 : one.settingTime) || '--',
                    location: (one === null || one === void 0 ? void 0 : one.location) || '--',
                    remoteLocalTime: one.remoteLocalTime || '--',
                    ip: (one === null || one === void 0 ? void 0 : one.ip) || '--',
                });
            }
            else {
                return getIn18Text('YOUJIANYUDDSJBDK', {
                    settingTimeZone: (one === null || one === void 0 ? void 0 : one.settingTimeZone) || '--',
                    settingTime: (one === null || one === void 0 ? void 0 : one.settingTime) || '--',
                    remoteLocalTime: one.remoteLocalTime || '--',
                });
            }
        }
        return '';
    }, [openRecordData]);
    const viewDetail = () => {
        if (!open) {
            getMailReadDetail && getMailReadDetail(content);
        }
        setOpen(!open);
    };
    const dayLimit = mailConfApi.getMailDayLimit();
    const overDay = useMemo(() => {
        var _a;
        const { entry: { sendTime }, } = content;
        const dateArr = (_a = sendTime === null || sendTime === void 0 ? void 0 : sendTime.trim()) === null || _a === void 0 ? void 0 : _a.split(/\s+/);
        if (!dateArr || (dateArr === null || dateArr === void 0 ? void 0 : dateArr.length) < 2) {
            return false;
        }
        const utcStr = dateArr[0] + 'T' + dateArr[1] + '+08:00';
        const sendValue = moment(utcStr);
        if (moment().add(-dayLimit.thirdDayLimit, 'day').isAfter(sendValue, 'day')) {
            return true;
        }
        else {
            return false;
        }
    }, [content]);
    useEffect(() => {
        setOpen(false);
    }, [id]);
    return (React.createElement(React.Fragment, null, overDay ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.over30Record },
            React.createElement(AlertWarn, { transform: "scale(0.8)" }),
            React.createElement("span", { className: styles.over30RecordText }, getIn18Text('WUFACHAKANCHAOGTDDKJL', { count: dayLimit.thirdDayLimit }))))) : (React.createElement(React.Fragment, null, (openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.count) ? (React.createElement(React.Fragment, null,
        (openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.count) === 1 && !forbid && (React.createElement("div", { className: styles.oneRecord },
            React.createElement(IconSuccess, { transform: "scale(0.8)" }),
            React.createElement("span", { className: styles.oneRecordText }, oneRecordText))),
        ((openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.count) > 1 || forbid) && (React.createElement("div", { className: styles.multiRecords },
            React.createElement("div", { className: styles.openRecordTitle },
                React.createElement(IconSuccess, { transform: "scale(0.8)" }),
                React.createElement("span", { className: styles.openText },
                    getIn18Text('YOUJIANYIBEIDAKC', { openRecordData: (openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.count) || 0 }),
                    !forbid ? (React.createElement("span", { className: styles.openBut, onClick: viewDetail }, openText)) : (React.createElement(React.Fragment, null)))),
            showTable && !forbid ? (React.createElement("div", { className: styles.openRecordTable },
                React.createElement(SiriusTable, { pagination: false, columns: process.env.BUILD_ISEDM ? columnsWaimao : columnsLx, dataSource: openRecordData.records, className: styles.openRecordList, rowClassName: styles.openRecordRow, scroll: { y: 155 } }))) : (React.createElement(React.Fragment, null)))))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.noOpenRecord },
            React.createElement(AlertWarn, { transform: "scale(0.8)" }),
            isThirdSend ? (React.createElement("span", null,
                React.createElement("span", null, getIn18Text('WUFAZHUIZYDZT')),
                React.createElement("span", { className: styles.noOpenRecordTextRed }, getIn18Text('ZHIYOUZAIWMTFSYJQKQY13')),
                React.createElement("span", null, getIn18Text('JIANYISHIYWMTFSYJ')))) : (React.createElement("span", { className: styles.noOpenRecordText }, getIn18Text('YOUJIANWEIBEIDAKG'))))))))));
};
export default OpenRecords;
